import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import avatarImg from "@/assets/images/avatar.svg";

import ConfirmDeleteModal from "../../../Insurance/ConfirmDeleteModal";
import AddInsurancePopup from "../../../Insurance/AddInsurancePopup";
import { addClickRecord, getClientId } from "../../../../Utils/helper";
// import useClientPage from "../contact-panel/hooks/useClientPage";
import { deleteInsurance } from "../../../../Redux/insurance/insuranceSlice";

import { useInsuranceData } from "./hooks/useInsuranceData";
import { useInsuranceModals } from "./hooks/useInsuranceModal";
import InsuranceList from "./insuranceList";

const InsurancePanelNew = ({ clientData, refetch, setShowInsuranceModal }) => {
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const dispatch = useDispatch();
  const {
    _insurances,
    billData,

    fetchMedicalBill,
    // refreshInsuranceData,
    // handleDeleteInsurance,
  } = useInsuranceData();

  const {
    showDeleteModal,
    selectedInsuranceDeletionId,
    modalShow,
    activeTab,
    openEditModal,
    closeEditModal,
    openDeleteModal,
    closeDeleteModal,
  } = useInsuranceModals();

  // Initial data fetch
  useEffect(() => {
    fetchMedicalBill();
    // refreshInsuranceData();
  }, [fetchMedicalBill]);

  const handleInsuranceCreation = () => {
    refetch();
    closeEditModal();
  };
  const handleDelete = async () => {
    await dispatch(deleteInsurance({ insurance_id: selectedInsuranceDeletionId }));
    closeDeleteModal();
    refetch();
  };
  // const handleDelete = async () => {
  //   if (selectedInsuranceDeletionId) {
  //     await handleDeleteInsurance(selectedInsuranceDeletionId);
  //     closeDeleteModal();
  //     refetch();
  //   }
  // };
  return (
    <>
      <InsuranceList
        insurances={clientData?.client?.client_insurances}
        name={` ${clientData?.client?.last_name || ""} ${clientData?.client?.first_name || ""}`}
        avatar={clientData?.client?.profile_pic ?? avatarImg}
        billData={billData}
        setShowInsuranceModal={setShowInsuranceModal}
        onEditInsurance={openEditModal}
        onExtractInsuranceData={(insurance) => {
          /* data is already handled in openEditModal */
          addClickRecord(999, page_id_click_record);
          setSelectedInsurance(insurance);
        }}
      />

      {modalShow && (
        <AddInsurancePopup
          insurance={selectedInsurance}
          show={modalShow}
          partyScope="client"
          initialParty={{
            type: "Client",
            id: clientData?.client?.id || getClientId(),
            name: [clientData?.client?.first_name, clientData?.client?.last_name]
              .filter(Boolean)
              .join(" "),
          }}
          billData={billData}
          onCreated={() => {
            handleInsuranceCreation();
            addClickRecord(999, page_id_click_record);
          }}
          handleClose={() => {
            addClickRecord(999, page_id_click_record);
            closeEditModal();
          }}
          initialTab={activeTab}
          onDelete={(id) => {
            addClickRecord(999, page_id_click_record);
            openDeleteModal(id);
          }}
        />
      )}

      {showDeleteModal && (
        <ConfirmDeleteModal
          handleClose={() => {
            addClickRecord(999, page_id_click_record);
            closeDeleteModal();
          }}
          handleDeleteSubmission={() => {
            addClickRecord(999, page_id_click_record);
            handleDelete();
          }}
        />
      )}
    </>
  );
};

export default InsurancePanelNew;
